import React from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';

export default function Footer() {
  return (
    <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
      <div className="border-t border-gray-200 py-8 sm:py-10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <span className="text-gray-500 text-sm">© 2025 Inspirafolio. Todos os direitos reservados.</span>
            <span className="text-gray-300">|</span>
            <Link to="/termos" className="text-gray-500 text-sm hover:text-indigo-600 transition-colors">
              Termos de Uso
            </Link>
            <span className="text-gray-300">|</span>
            <Link to="/privacidade" className="text-gray-500 text-sm hover:text-indigo-600 transition-colors">
              Privacidade
            </Link>
          </div>
          
          <div className="flex items-center gap-1 text-gray-500 text-sm">
            Desenvolvido com <Heart className="h-3 w-3 text-red-500 mx-0.5" /> por <a href="https://rogerfernando.com.br" target="_blank" rel="noopener noreferrer" className="hover:text-indigo-600 transition-colors">Roger Fernando</a>
          </div>
        </div>
      </div>
    </div>
  );
}